import { useNavigate } from 'react-router-dom';
import Success from '~/components/Success/Success';
import { HelmetHead } from '~/components/common';
import { Header } from '~/components/common/Header';
import { PAGE_ROUTE } from '~/constants';
import SuccessImage from '~/assets/img/completion_images/girls_smiling_and_waving.png';

export default function ResetPasswordSuccess() {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(PAGE_ROUTE.SIGNIN_HOME);
  };

  return (
    <>
      <HelmetHead title='Success' />
      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
        </Header.Section>
      </Header.Root>
      <Success
        image={SuccessImage}
        subTitle={`Your password has been changed.`}
        buttonTitle='Sign in'
        onClick={handleOnClick}
      />
    </>
  );
}
